import { render, staticRenderFns } from "./FormFormat.vue?vue&type=template&id=7af4028b&scoped=true"
import script from "./FormFormat.vue?vue&type=script&lang=js"
export * from "./FormFormat.vue?vue&type=script&lang=js"
import style0 from "./FormFormat.vue?vue&type=style&index=0&id=7af4028b&lang=scss"
import style1 from "./FormFormat.vue?vue&type=style&index=1&id=7af4028b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af4028b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7af4028b')) {
      api.createRecord('7af4028b', component.options)
    } else {
      api.reload('7af4028b', component.options)
    }
    module.hot.accept("./FormFormat.vue?vue&type=template&id=7af4028b&scoped=true", function () {
      api.rerender('7af4028b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormFormat.vue"
export default component.exports